(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TeamManagementAlertSystemController', TeamManagementAlertSystemController);

    TeamManagementAlertSystemController.$inject = ['$state', 'entity', 'Team', 'domain', 'AlertRules', 'AlertService', 'AlertSystem', 'pagingParams', 'paginationConstants', 'ParseLinks', '$uibModal', '$rootScope'];

    function TeamManagementAlertSystemController($state, entity, Team, domain, AlertRules, AlertService, AlertSystem, pagingParams, paginationConstants, ParseLinks, $uibModal, $rootScope) {
        var vm = this;

        vm.user = entity;
        vm.domain = domain;
        vm.predicates = pagingParams.predicates;
        vm.systemPredicates = pagingParams.systemPredicates;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;
        vm.currentState = "team-alert-system";
        vm.systemWarningItemLimit = 4;
        vm.enableMail = [];
        vm.enableSlack = [];
        vm.enableTelegram = [];
        vm.enableWebhook = [];
        vm.wac = [];
        vm.licence = $rootScope.licence;

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder !== "null")
            vm.predicates = JSON.parse(retrievedOrder);
        retrievedOrder = localStorage.getItem(vm.currentState+"system");
        if (retrievedOrder != null && retrievedOrder !== "null") {
            vm.systemPredicates = JSON.parse(retrievedOrder);

        }
        vm.transition = transition;

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc' ));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        function loadAll() {
            AlertRules.getWarningByUser({
                login: $state.params.login,
                page: pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(vm.predicates,"")
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.warnings = data.warnings;
                vm.notifications = data.notification;
                vm.page = pagingParams.page;
                enableAlertSystem(vm.warnings);
                AlertSystem.getUserAlertSystem({user: $state.params.login}, onAlertSuccess);
            }

            AlertRules.getSystemWarningByUser({
                login: $state.params.login,
                page: pagingParams.systemPage - 1,
                size: vm.systemWarningItemLimit,
                sort: sort(vm.systemPredicates,"system")
            }, onSuccessSystem, onError);

            function onSuccessSystem(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.systemTotalItems = headers('X-Total-Count');
                vm.systemQueryCount = vm.systemTotalItems;
                vm.systemWarnings = data.warnings;
                vm.notifications = data.notification;
                vm.systemPage = pagingParams.systemPage;
                enableAlertSystem(vm.systemWarnings);
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
            function onAlertSuccess(results) {
                vm.emailDisabled = false;
                vm.slackDisabled = false;
                vm.telegramDisabled = false;
                vm.webhookDisabled = false;
                results.forEach(function (alert) {
                    if(alert.alertSystemType.name == "email") {
                        vm.email = alert;
                        vm.userEmail = alert.actionIdentifier;
                        vm.emailDisabled = alert.adminDisabled;
                    } else if(alert.alertSystemType.name == "slack") {
                        vm.slack = alert;
                        vm.slackDisabled = alert.adminDisabled;
                        vm.userSlack = alert.actionIdentifier;
                    } else if(alert.alertSystemType.name == "telegram") {
                        vm.telegram = alert;
                        vm.telegramDisabled = alert.adminDisabled;
                        vm.userTelegram = alert.actionIdentifier;
                    } else if(alert.alertSystemType.name == "webhook") {
                        vm.webhook = alert;
                        vm.webhookDisabled = alert.adminDisabled;
                        vm.userWebhok = alert.actionIdentifier;
                    }
                });
            }

        }

        vm.deleteAlert = function (id) {
            $uibModal.open({
                templateUrl: 'app/account/general-settings/modals/delete-dialog.html',
                controller:function($uibModalInstance){
                    var vm=this;
                    vm.clear = clear;
                    vm.stop = stop;
                    function stop() {
                        AlertSystem.delete({id: id}, function (result) {
                            $state.reload();
                        });
                        $uibModalInstance.close();
                    }
                    function clear() {
                        $uibModalInstance.dismiss('cancel');
                    }
                },
                controllerAs:'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function () {
                transition(false);
            });
        };

        function enableAlertSystem(warnings){
            warnings.forEach(function (warning) {
                vm.wac[warning.id] = {};
                vm.wac[warning.id].email = false;
                vm.wac[warning.id].slack = false;
                vm.wac[warning.id].telegram = false;
                vm.wac[warning.id].webhook = false;
                warning.warningAlertConfigurations.forEach(function (wac) {
                    var name = wac.alertSystemType.name;
                    vm.wac[warning.id][name] = wac.active;
                });
                if(!(vm.domain.enableAlerting && vm.domain.mailAlerting))
                    warning.relatedAlertSystemType.Channelemail = vm.wac[warning.id].email = vm.domain.enableAlerting && vm.domain.mailAlerting;
                if(!(vm.domain.enableAlerting && vm.domain.slackAlerting))
                    warning.relatedAlertSystemType.Channelslack = vm.wac[warning.id].slack = vm.domain.enableAlerting && vm.domain.slackAlerting;
                if(!(vm.domain.enableAlerting && vm.domain.telegramAlerting))
                    warning.relatedAlertSystemType.Channeltelegram = vm.wac[warning.id].telegram = vm.domain.enableAlerting && vm.domain.telegramAlerting;
                if(!(vm.domain.enableAlerting && vm.domain.webhookAlerting))
                    warning.relatedAlertSystemType.Channelwebhook = vm.wac[warning.id].webhook = vm.domain.enableAlerting && vm.domain.webhookAlerting;
                vm.enableMail[warning.id] =  warning.relatedAlertSystemType.email != null && warning.relatedAlertSystemType.email != undefined && warning.relatedAlertSystemType.Channelemail != undefined && warning.relatedAlertSystemType.Channelemail && vm.wac[warning.id].email;
                vm.enableSlack[warning.id] = warning.relatedAlertSystemType.slack != null && warning.relatedAlertSystemType.slack != undefined && warning.relatedAlertSystemType.Channelslack != undefined && warning.relatedAlertSystemType.Channelslack && vm.wac[warning.id].slack;
                vm.enableTelegram[warning.id] = warning.relatedAlertSystemType.telegram != null && warning.relatedAlertSystemType.telegram != undefined && warning.relatedAlertSystemType.Channeltelegram != undefined && warning.relatedAlertSystemType.Channeltelegram && vm.wac[warning.id].telegram;
                vm.enableWebhook[warning.id] = warning.relatedAlertSystemType.webhook != null && warning.relatedAlertSystemType.webhook != undefined && warning.relatedAlertSystemType.Channelwebhook != undefined && warning.relatedAlertSystemType.Channelwebhook && vm.wac[warning.id].webhook;
            });
        }

        vm.user.$promise.then(loadAll());


        function transition(notify) {
            notify = notify === false ? notify : true;
            $state.transitionTo($state.$current, {
                page: vm.page,
                predicates: vm.predicates,
                systemPredicates: vm.systemPredicates,
                sort: sort(vm.predicates,""),
                systemPage: vm.systemPage,
                systemSort: sort(vm.systemPredicates,"system"),
                itemsPerPageChosen: vm.itemsPerPageChosen,
                entity: vm.user,
                domain : vm.domain,
                login :  vm.user.login
            }, {notify: notify, location: "replace"});
        }



        vm.toggleStatus = function(type, status) {
            AlertRules.domainToggleChannel({login: vm.user.login, type: type, status: status}, function () {
                loadAll();
            });
        };
    }
})();
